"use client";

import { motion, useReducedMotion } from "framer-motion";
import { EASE_SMOOTH } from "@/components/motion/constants";

const LEAVES = [
  { left: "8%", top: "12%", rotate: -18, delay: 0, duration: 7 },
  { left: "88%", top: "18%", rotate: 24, delay: 1.2, duration: 8 },
  { left: "4%", top: "72%", rotate: 12, delay: 0.6, duration: 6.5 },
  { left: "92%", top: "68%", rotate: -30, delay: 2, duration: 7.5 },
  { left: "48%", top: "4%", rotate: 8, delay: 0.3, duration: 9 },
] as const;

function LeafIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M12 2C8 8 4 10 4 14c0 3.3 2.7 6 6 6 1.5 0 2.9-.55 4-1.45C15.1 20 16.5 20.5 18 20.5c3.3 0 6-2.7 6-6.5 0-4-4-6-8-12-1 2-2.5 3.5-4 4.5z" />
    </svg>
  );
}

export function AboutStoryBackground() {
  const reduced = useReducedMotion();

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <svg
        className="about-story-svg absolute -right-24 top-0 h-[120%] w-[70%] opacity-[0.07] text-[var(--programs-green)]"
        viewBox="0 0 400 600"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
      >
        <path
          d="M0 80C80 40 160 120 240 80C320 40 360 100 400 60V600H0V80Z"
          fill="currentColor"
        />
        <path
          d="M0 280C100 240 200 320 300 260C340 240 370 270 400 250V600H0V280Z"
          fill="currentColor"
          opacity="0.6"
        />
        <circle cx="320" cy="140" r="80" fill="currentColor" opacity="0.35" />
      </svg>

      <svg
        className="about-story-svg absolute -left-16 bottom-0 h-2/3 w-1/2 opacity-[0.05] text-[var(--charity-gold)]"
        viewBox="0 0 300 400"
        fill="none"
      >
        <path
          d="M0 200Q150 80 300 200V400H0V200Z"
          fill="currentColor"
        />
      </svg>

      {!reduced &&
        LEAVES.map((leaf, i) => (
          <motion.div
            key={i}
            className="about-story-leaf absolute text-[var(--programs-green)]/25"
            style={{
              left: leaf.left,
              top: leaf.top,
              rotate: leaf.rotate,
            }}
            animate={{
              y: [0, -12, 0],
              rotate: [leaf.rotate, leaf.rotate + 8, leaf.rotate],
            }}
            transition={{
              duration: leaf.duration,
              delay: leaf.delay,
              repeat: Infinity,
              ease: EASE_SMOOTH,
            }}
          >
            <LeafIcon className="h-6 w-6 md:h-8 md:w-8" />
          </motion.div>
        ))}
    </div>
  );
}
